import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return from(authService.getAccessToken()).pipe(
    switchMap((token) => {
      if (token) {
        const authRequest = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });

        return next(authRequest);
      } else {
        console.warn('No access token available for request to:', req.url);
        return next(req);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.error('Unauthorized request, signing out user');
        authService.signOut().catch(console.error);
      } else if (error.status === 403) {
        console.error('Forbidden request, redirecting to unauthorized page');
      }
      return throwError(() => error);
    })
  );
};
